import { Box } from "@chakra-ui/react";

import { Pagination } from "components/Pagination";

import { ExpiredAppointmentsMobileRows } from "./ExpiredAppointmentsMobileRows";

interface IProps {
  totalAppointments: number;
  limit: number;
}

const ExpiredAppointmentsMobile = ({ totalAppointments, limit }: IProps) => {
  return (
    <>
      <ExpiredAppointmentsMobileRows limit={limit} />
      <Box mt={4}>
        <Pagination total={totalAppointments} limit={limit} />
      </Box>
    </>
  );
};

export { ExpiredAppointmentsMobile };
